import React, { useState, useEffect } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  TextField,
  Checkbox,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import api from "../../api/api";

const TableConfigList = ({ businessTypeId, onModulesUpdate }) => {
  const [columns, setColumns] = useState([]);
  const [newColumn, setNewColumn] = useState({
    column_name: "",
    is_visible: true,
    column_order: 1,
  });

  // Загрузка конфигураций колонок
  const fetchColumns = async () => {
    try {
      const response = await api.get(
        `/table-configs/?business_type_id=${businessTypeId}`
      );
      setColumns(response.data);
      const updatedModules = response.data.map(
        (col) => col.config_data.column_name
      );
      onModulesUpdate(updatedModules);
    } catch (error) {
      console.error("Ошибка загрузки конфигураций колонок:", error);
    }
  };

  useEffect(() => {
    if (businessTypeId) {
      fetchColumns();
    }
  }, [businessTypeId]);

  // Добавление колонки
  const addColumn = async () => {
    try {
      const payload = {
        name: "Новая колонка", // Общее имя
        business_type_id: businessTypeId,
        config_data: newColumn,
      };
      await api.post("/table-configs/", payload);
      fetchColumns(); // Перезагружаем список колонок
      onModulesUpdate(); // Уведомляем родительский компонент о необходимости обновления
      setNewColumn({ column_name: "", is_visible: true, column_order: 1 });
    } catch (error) {
      console.error("Ошибка добавления колонки:", error);
    }
  };
  // Удаление колонки
  const deleteColumn = async (columnId) => {
    try {
      await api.delete(`/table-configs/${columnId}`);
      fetchColumns();
    } catch (error) {
      console.error("Ошибка удаления колонки:", error);
    }
  };

  return (
    <div>
      <h3>Конфигурация колонок</h3>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Название колонки</TableCell>
            <TableCell>Видимость</TableCell>
            <TableCell>Порядок</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {columns.map((col) => (
            <TableRow key={col.id}>
              <TableCell>{col.config_data.column_name}</TableCell>
              <TableCell>{col.config_data.is_visible ? "Да" : "Нет"}</TableCell>
              <TableCell>{col.config_data.column_order}</TableCell>
              <TableCell>
                <IconButton color="error" onClick={() => deleteColumn(col.id)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell>
              <TextField
                label="Название колонки"
                value={newColumn.column_name}
                onChange={(e) =>
                  setNewColumn({ ...newColumn, column_name: e.target.value })
                }
                fullWidth
              />
            </TableCell>
            <TableCell>
              <Checkbox
                checked={newColumn.is_visible}
                onChange={(e) =>
                  setNewColumn({ ...newColumn, is_visible: e.target.checked })
                }
              />
            </TableCell>
            <TableCell>
              <TextField
                type="number"
                label="Порядок"
                value={newColumn.column_order}
                onChange={(e) =>
                  setNewColumn({
                    ...newColumn,
                    column_order: parseInt(e.target.value),
                  })
                }
                fullWidth
              />
            </TableCell>
            <TableCell>
              <Button variant="contained" color="primary" onClick={addColumn}>
                Добавить
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};

export default TableConfigList;
